import React from "react";
import Add from "./Add";
import List from "./List";
import Summary from "./Summary";
import { Switch, Route } from "react-router-dom";

function CreditVouchers({ match }) {
  const { path } = match;
  return (
    <Switch>
      <Route exact path={path} component={List}></Route>
      <Route path={`${path}/Add`} component={Add}></Route>
      <Route path={`${path}/:id/summary`} component={Summary}></Route>
    </Switch>
  );
}

export { CreditVouchers };
